import { render, staticRenderFns } from "./myQuestions.vue?vue&type=template&id=7fba84a6&scoped=true"
import script from "./myQuestions.vue?vue&type=script&lang=js"
export * from "./myQuestions.vue?vue&type=script&lang=js"
import style0 from "./myQuestions.vue?vue&type=style&index=0&id=7fba84a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fba84a6",
  null
  
)

export default component.exports